import i18n from '@/i18n';
import { normalizeTemuShopType } from '@/temu-platform/constants/temuRoutes';

const FULL_FALLBACK = {
  headline: '对接 TEMU 全托管后，供货发品与备货更顺一截',
  lead: '把货品发布、模板库与全托备货发货收进同一工作区——全托发品不选站点·仓·运费；跨境核价/营销属平台自研专属接口，本工作区不提供。',
  highlights: [
    ['发品与模板就位', '发布产品、产品信息、草稿与发布记录同壳；全托发品跳过站点·仓·运费步骤。'],
    ['备货发货入口', '订单管理以「备货发货」为侧栏可见履约入口（其余履约子项按平台权限逐步开放，不以未上线能力宣传）。'],
    ['合规与店铺信息', '合规资质与店铺信息可同步维护；退货等售后按全托规则分流处理。'],
    ['店铺类型强隔离', '工作区 Session 绑定全托管；不可操作半托仓运费或本土价宣菜单，跨类型需回门禁重验。'],
  ],
};

const LOCAL_FALLBACK = {
  headline: '对接 TEMU 本土后，本地发品与价宣更顺一截',
  lead: '把货品发布、价格处理、本土营销与销售订单收进同一工作区——本土发品不绑跨境站点·仓·运费；全托备货履约套件不在此轨提供。',
  highlights: [
    ['本土发品链路', '产品发布、产品信息、草稿与发布记录同壳；发品跳过跨境站点/仓/运费步骤。'],
    ['价格处理可用', '本土价单（价格处理）可进工作区；与跨境半托/全托不可用的核价接口区分开。'],
    ['营销与销售订单', '本土促销活动可进入；订单走销售订单与退货售后（非全托备货履约套件）。'],
    ['店铺类型强隔离', '工作区 Session 绑定本土；与半托/全托分离，跨类型需回门禁重验。'],
  ],
};

const SEMI_FALLBACK = {
  headline: '对接 TEMU 半托管后，发品与销售订单更顺一截',
  lead: '把货品发布、模板库、合规与销售订单收进同一工作区——半托发品可配站点·仓·运费；跨境核价/调价与跨境营销活动属平台自研专属，本工作区不提供。',
  highlights: [
    ['设计到上架不断层', 'IPE 产出直连半托货品链路：发布、产品信息、草稿与发布记录同一工作流。'],
    ['仓与运费可配置', '模板库含发货仓库与运费模板，服务半托发品必填的站点/仓/运费步骤。'],
    ['销售订单与合规', '订单列表与退货退款按半托销售售后同步；合规资质与店铺信息可维护。'],
    ['店铺类型强隔离', '与 SHEIN / TikTok 工作区分离；半托 Session 不可操作全托履约或本土价宣专属能力。'],
  ],
};

function story(branch, fallback) {
  const text = (key, zh) => i18n.t(`temuGate.${branch}.${key}`, { ns: 'workbench', defaultValue: zh });
  return {
    headline: text('headline', fallback.headline),
    lead: text('lead', fallback.lead),
    highlights: fallback.highlights.map(([title, desc], index) => ({
      title: text(`h${index + 1}Title`, title),
      desc: text(`h${index + 1}Desc`, desc),
    })),
  };
}

/**
 * TEMU 门禁左侧叙事文案（随托管类型切换）。
 * 口径对齐 TEMU_TRACK_GATED_PATHS / navItemsForShopTypeSlug：
 * - 半托/全托：跨境核价·营销属平台自研专属，ISV 不可用，文案不得承诺；
 * - 全托：备货/打印/销量/包装/广告/寄样等履约子项可用；
 * - 本土：价格处理与营销活动可用；发品可走仓/运费。
 */
export function gateCopyForTemuShopType(shopType) {
  const type = normalizeTemuShopType(shopType);
  if (type === '全托管') return story('full', FULL_FALLBACK);
  if (type === '本土') return story('local', LOCAL_FALLBACK);
  return story('semi', SEMI_FALLBACK);
}
